export enum EmployeeStatus {
    New = 'New',
    Approved = 'Approved',
    Rejected = 'Rejected',
    Leaver = 'Leaver'
}
